import React, { useEffect, useState } from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const Nav = ({ content }) => {
    useEffect(() => {}, []);

    return (
        <div className={styles.nav}>
            <div className={styles.navBox}>
                <a href={content.logo1Url ? content.logo1Url : '#!'} target={content.logo1Url ? '_blank' : '_self'} className={styles.logo1Link}>
                    <img className={styles.logo1} src={content.logo1} />
                </a>
                <div className={styles.navList}>
                    {content.navList.map((item, index) => {
                        return (
                            <a key={index} href={item.url} target="_blank" className={styles.navItem}>
                                {item.title}
                            </a>
                        );
                    })}
                </div>
                <a href={content.logo2Url ? content.logo2Url : '#!'} target={content.logo2Url ? '_blank' : '_self'} className={styles.logo2Link}>
                    <img className={styles.logo2} src={content.logo2} />
                </a>
            </div>
        </div>
    );
};

Nav.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Nav);
